var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('call-line-component',{attrs:{"lines":8,"title":_vm.$t('admin_calls'),"color":"success","type":"admin"}})}
var staticRenderFns = []

export { render, staticRenderFns }